import { Typography } from '@alltrails/core';
import { FormattedMessage } from 'react-intl';
import type { SubscriptionTier } from '@alltrails/types/SubscriptionTier';
import Image from '@alltrails/core/components/Image';
import styles from './AppStoreSubscription.module.scss';
import iconImage from './assets/app-subscription-icon.avif';

type AppStoreSubscriptionProps = {
  subscriptionTier: SubscriptionTier;
};

export default function AppStoreSubscription({ subscriptionTier }: AppStoreSubscriptionProps) {
  return (
    <div className={styles.container}>
      <Image src={iconImage} alt="" width={74} height={74} />
      <div className={styles.textContainer}>
        <Typography component="p" variant="text200bold">
          {subscriptionTier === 'plus' ? 'Plus' : 'Peak'}
        </Typography>
        <Typography component="p" variant="text200" color="tertiary">
          AllTrails
        </Typography>
        <Typography component="p" variant="text200" color="tertiary">
          <FormattedMessage defaultMessage="Annual Subscription" />
        </Typography>
      </div>
    </div>
  );
}
